import React, { useMemo } from 'react';
import FormGenerator from 'app/containers/Designer/Form/components/FormGenerator';

const geoCodingOptions = [
    { value: 'google', label: 'Google' },
    { value: 'esri-arcgis', label: 'Esri-ArcGIS' },
    // { value: 'WFS - Web Feature Service', label: 'WFS - Web Feature Service' },
];

const GeocodingAdminSection = ({ data, onChange, formRef, isUnCollapsed, formRevertKey }) => {
    const header = data?.geocodingService === 'google' ? 'Google' : 'Geocoding';
    const geoCodingComponents = useMemo(() => {
        return [
            {
                type: 'panel',
                properties: {
                    header: 'Geocoding Services',
                    expanded: isUnCollapsed,
                },
                children: [
                    {
                        type: 'radioGroup',
                        properties: {
                            name: 'geocodingService',
                            options: geoCodingOptions,
                            defaultValue: 'google',
                        },
                    },
                ],
            },
            {
                type: 'panel',
                properties: {
                    header,
                    expanded: isUnCollapsed,
                },
                children: [
                    {
                        type: 'text',
                        properties: {
                            name: 'beGoogleApiKey',
                            label: `${header} API key`,
                            isVisible: (data) => data?.geocodingService === 'google',
                        },
                        constraints: {
                            required: true,
                        },
                    },
                    {
                        type: 'text',
                        properties: {
                            name: 'esriToken',
                            label: 'API Key',
                            isVisible: (data) => data?.geocodingService === 'esri-arcgis',
                        },
                    },
                    {
                        type: 'text',
                        properties: {
                            name: 'esriLocatorBaseUrl',
                            label: 'Server URL',
                            isVisible: (data) => data?.geocodingService === 'esri-arcgis',
                        },
                        constraints: {
                            required: true,
                        },
                    },
                    {
                        type: 'number',
                        properties: {
                            name: 'esriMaxLocation',
                            label: 'Max Location',
                            isVisible: (data) => data?.geocodingService === 'esri-arcgis',
                        },
                        constraints: {
                            required: true,
                        },
                    },
                ],
            },
        ];
    }, [header, isUnCollapsed]);
    return (
        <>
            <FormGenerator key={formRevertKey} onChange={onChange} ref={formRef} data={data} disabled={false} components={geoCodingComponents} />
        </>
    );
};
export default GeocodingAdminSection;
